/** German, keyed by the Slovak text (see i18n/index.ts). */
export const de: Record<string, string> = {
  'Platnosť prihlásenia vypršala, prihláste sa prosím znova': 'Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an',
  'Pneumatiky: {label}': 'Reifen: {label}',
  'Pneumatiky nezadané': 'Reifen nicht erfasst',
  'ŠPZ': 'Kennzeichen',
  'Značka': 'Marke',
  'Model': 'Modell',
  'Rok výroby': 'Baujahr',
  'VIN': 'FIN',
  'Palivo': 'Kraftstoff',
  'Stav': 'Status',
  'Stav km': 'Kilometerstand',
  'Poznámky': 'Notizen',
  'Vytvoril (ID)': 'Erstellt von (ID)',
  'Meno': 'Vorname',
  'Priezvisko': 'Nachname',
  'Osobné číslo': 'Personalnummer',
  'Oddelenie': 'Abteilung',
  'Telefón': 'Telefon',
  'E-mail': 'E-Mail',
  'Číslo VP': 'Führerscheinnummer',
  'Platnosť VP': 'Führerschein gültig bis',
  'Aktívne': 'Aktiv',
  'Vozidlo (ID)': 'Fahrzeug (ID)',
  'Vodič (ID)': 'Fahrer (ID)',
  'Pridelené': 'Zugewiesen',
  'Vrátené': 'Zurückgegeben',
  'Počiatočné km': 'Anfangs-km',
  'Konečné km': 'End-km',
  'Účel': 'Zweck',
  'Dátum servisu': 'Servicedatum',
  'Typ servisu': 'Serviceart',
  'Popis': 'Beschreibung',
  'Km pri servise': 'Km beim Service',
  'Cena': 'Preis',
  'Servis': 'Werkstatt',
  'Faktúra': 'Rechnung',
  'Ďalší servis': 'Nächster Service',
  'Ďalší servis (km)': 'Nächster Service (km)',
  'Názov': 'Titel',
  'Typ dokumentu': 'Dokumenttyp',
  'Súbor': 'Datei',
  'Názov súboru': 'Dateiname',
  'Typ súboru': 'Dateityp',
  'Veľkosť': 'Größe',
  'Nahral (ID)': 'Hochgeladen von (ID)',
  'Nahrané': 'Hochgeladen',
  'Platnosť do': 'Gültig bis',
  'Používateľ': 'Benutzer',
  'Celé meno': 'Vollständiger Name',
  'Rola': 'Rolle',
  'Posledné prihlásenie': 'Letzte Anmeldung',
  'Názov spoločnosti': 'Firmenname',
  'Hlavná farba': 'Hauptfarbe',
  'Doplnková farba': 'Nebenfarbe',
  'Logo': 'Logo',
  'Logo (tmavé)': 'Logo (dunkel)',
  'Žiadne zmeny': 'Keine Änderungen',
  'Systém': 'System',
  'Dátum': 'Datum',
  'Vozidlo': 'Fahrzeug',
  'Typ': 'Typ',
  'Km': 'Km',
  'Akcie': 'Aktionen',
  'Upraviť': 'Bearbeiten',
  'Zmazať': 'Löschen',
  'Zmazať dokument': 'Dokument löschen',
  'Naozaj zmazať dokument {title}? Súbor bude natrvalo odstránený.': 'Dokument {title} wirklich löschen? Die Datei wird endgültig entfernt.',
  'Dokument bol zmazaný': 'Das Dokument wurde gelöscht',
  'Zobraziť': 'Anzeigen',
  'Stiahnuť': 'Herunterladen',
  'Vodič': 'Fahrer',
  'Trasa': 'Strecke',
  'Vzdialenosť': 'Entfernung',
  'Doba': 'Dauer',
  'Mesiac': 'Monat',
  'Najazdené': 'Gefahren',
  '{count} jázd': '{count} Fahrten',
  ' · súkr. {privateKm}': ' · privat {privateKm}',
  'Tachometer': 'Tachostand',
  'Navštívené miesta': 'Besuchte Orte',
  'Zmazať mesiac': 'Monat löschen',
  'Vozidlo bolo pridelené': 'Das Fahrzeug wurde zugewiesen',
  'Pridelenie sa nepodarilo vytvoriť': 'Die Zuweisung konnte nicht erstellt werden',
  'Prideliť vozidlo': 'Fahrzeug zuweisen',
  'Prideliť je možné iba aktívne vozidlo, ktoré práve nikto nemá.': 'Zugewiesen werden kann nur ein aktives Fahrzeug, das gerade niemand hat.',
  'Zrušiť': 'Abbrechen',
  'Prideliť': 'Zuweisen',
  'Vyberte vozidlo': 'Wählen Sie ein Fahrzeug',
  'Vyberte vodiča': 'Wählen Sie einen Fahrer',
  'Dátum a čas prevzatia': 'Datum und Uhrzeit der Übernahme',
  'Počiatočný stav km': 'Anfangskilometerstand',
  'Aktuálne v evidencii: {currentKm} km': 'Derzeit erfasst: {currentKm} km',
  'napr. služobné auto, cesta do Košíc': 'z. B. Dienstwagen, Fahrt nach Košice',
  'Pridelenie bolo ukončené': 'Die Zuweisung wurde beendet',
  'Pridelenie sa nepodarilo ukončiť': 'Die Zuweisung konnte nicht beendet werden',
  'Vrátenie vozidla': 'Rückgabe des Fahrzeugs',
  'Ukončiť pridelenie': 'Zuweisung beenden',
  'Dátum a čas vrátenia': 'Datum und Uhrzeit der Rückgabe',
  'Konečný stav km': 'End-Kilometerstand',
  'Počiatočný stav: {startKm} km': 'Anfangskilometerstand: {startKm} km',
  'Nesmie byť nižší ako počiatočný stav': 'Darf nicht niedriger als der Anfangsstand sein',
  'Poznámka k vráteniu': 'Notiz zur Rückgabe',
  'napr. poškodenie, stav paliva': 'z. B. Schäden, Tankfüllung',
  'Vozidlo bolo uložené': 'Das Fahrzeug wurde gespeichert',
  'Vozidlo bolo vytvorené': 'Das Fahrzeug wurde angelegt',
  'Vozidlo sa nepodarilo uložiť': 'Das Fahrzeug konnte nicht gespeichert werden',
  'Upraviť vozidlo {plate}': 'Fahrzeug {plate} bearbeiten',
  'Nové vozidlo': 'Neues Fahrzeug',
  'Uložiť': 'Speichern',
  'Vytvoriť': 'Anlegen',
  'BA-123AB': 'BA-123AB',
  'ŠPZ je povinná': 'Kennzeichen ist erforderlich',
  'Max. 20 znakov': 'Max. 20 Zeichen',
  'Škoda': 'Škoda',
  'Značka je povinná': 'Marke ist erforderlich',
  'Octavia': 'Octavia',
  'Model je povinný': 'Modell ist erforderlich',
  'Neplatný rok': 'Ungültiges Jahr',
  'Stav tachometra (km)': 'Kilometerstand (km)',
  'Nesmie byť záporné': 'Darf nicht negativ sein',
  'Zmluva {number} bola vygenerovaná': 'Vertrag {number} wurde erstellt',
  'Zmluvu sa nepodarilo vygenerovať': 'Der Vertrag konnte nicht erstellt werden',
  'Generovať zmluvu': 'Vertrag erstellen',
  'Zmluva o nájme sa vyplní údajmi pracovníka a vozidla a stiahne sa ako dokument Word. Vozidlo sa zároveň pridelí pracovníkovi (Pridelenie).': 'Der Mietvertrag wird mit den Daten des Mitarbeiters und des Fahrzeugs ausgefüllt und als Word-Dokument heruntergeladen. Das Fahrzeug wird dem Mitarbeiter zugleich zugewiesen (Zuweisungen).',
  'Generovať': 'Erstellen',
  'Pracovník': 'Mitarbeiter',
  'Vyberte pracovníka': 'Wählen Sie einen Mitarbeiter',
  'Od': 'Von',
  'Zadajte dátum': 'Geben Sie ein Datum ein',
  'Do': 'Bis',
  'Dátum „do“ nesmie byť skôr ako „od“': 'Das Datum „bis“ darf nicht vor „von“ liegen',
  'Cena za deň (€ bez DPH)': 'Preis pro Tag (€ ohne MwSt.)',
  'nevyplnené – doplní sa ručne': 'nicht ausgefüllt – wird von Hand ergänzt',
  'Spolu za {days} deň: {total} bez DPH': 'Gesamt für {days} Tag: {total} ohne MwSt.',
  'Cena nesmie byť záporná': 'Der Preis darf nicht negativ sein',
  '{rejected} súbor(ov) nie je možné nahrať – nepodporovaný typ alebo väčší ako 50 MB': '{rejected} Datei(en) können nicht hochgeladen werden – nicht unterstützter Typ oder größer als 50 MB',
  'Vyberte aspoň jeden súbor': 'Wählen Sie mindestens eine Datei',
  'Dokument bol nahraný': 'Das Dokument wurde hochgeladen',
  'Nahraných {uploaded} dokumentov': '{uploaded} Dokumente hochgeladen',
  'Nahrávanie zlyhalo': 'Hochladen fehlgeschlagen',
  ' (nahraných {uploaded} z {files})': ' ({uploaded} von {files} hochgeladen)',
  'Nahrať dokumenty': 'Dokumente hochladen',
  'Nahrávanie {progress} %': 'Hochladen {progress} %',
  'Nahrať': 'Hochladen',
  'Pustite súbory sem': 'Dateien hier ablegen',
  'Pretiahnite súbory sem alebo kliknite pre výber': 'Dateien hierher ziehen oder zum Auswählen klicken',
  'PDF, obrázky, Word, Excel · max. 50 MB': 'PDF, Bilder, Word, Excel · max. 50 MB',
  'Odobrať {name}': '{name} entfernen',
  'Použije sa názov súboru': 'Der Dateiname wird verwendet',
  'Predvolene: názov súboru': 'Standard: Dateiname',
  'Upozornenie 30 dní pred koncom platnosti': 'Erinnerung 30 Tage vor Ablauf',
  'Dokument bol uložený': 'Das Dokument wurde gespeichert',
  'Dokument sa nepodarilo uložiť': 'Das Dokument konnte nicht gespeichert werden',
  'Upraviť dokument': 'Dokument bearbeiten',
  'Zadajte názov': 'Geben Sie einen Titel ein',
  'Vodič bol uložený': 'Der Fahrer wurde gespeichert',
  'Vodič bol vytvorený': 'Der Fahrer wurde angelegt',
  'Vodiča sa nepodarilo uložiť': 'Der Fahrer konnte nicht gespeichert werden',
  'Upraviť vodiča {firstName} {lastName}': 'Fahrer {firstName} {lastName} bearbeiten',
  'Nový vodič': 'Neuer Fahrer',
  'Meno je povinné': 'Vorname ist erforderlich',
  'Priezvisko je povinné': 'Nachname ist erforderlich',
  'Neplatný e-mail': 'Ungültige E-Mail',
  'Číslo vodičského preukazu': 'Führerscheinnummer',
  'Platnosť vodičského preukazu': 'Führerschein gültig bis',
  'Údaje pre zmluvy': 'Angaben für Verträge',
  'Použijú sa pri generovaní zmlúv. Nevyplnené údaje zostanú v zmluve vybodkované na ručné doplnenie.': 'Werden beim Erstellen von Verträgen verwendet. Nicht ausgefüllte Angaben bleiben im Vertrag gepunktet zum Ausfüllen von Hand.',
  'Dátum narodenia': 'Geburtsdatum',
  'Typ pracovného vzťahu': 'Art des Arbeitsverhältnisses',
  'Nevyplnené': 'Nicht ausgefüllt',
  'Adresa trvalého pobytu': 'Wohnadresse',
  'Ulica a číslo, PSČ Obec': 'Straße und Hausnummer, PLZ Ort',
  'IČO': 'Firmen-ID (IČO)',
  'DIČ': 'Steuer-ID (DIČ)',
  'Aktívny vodič': 'Aktiver Fahrer',
  'Vyberte vozidlo…': 'Fahrzeug wählen…',
  'Načítava sa…': 'Wird geladen…',
  'Vyberte vodiča…': 'Fahrer wählen…',
  'Pokuta bola uložená': 'Das Bußgeld wurde gespeichert',
  'Pokuta bola pridaná': 'Das Bußgeld wurde hinzugefügt',
  'Pokutu sa nepodarilo uložiť': 'Das Bußgeld konnte nicht gespeichert werden',
  'Upraviť pokutu': 'Bußgeld bearbeiten',
  'Nová pokuta': 'Neues Bußgeld',
  'Pridať': 'Hinzufügen',
  'Krajina': 'Land',
  'Dátum priestupku': 'Datum des Verstoßes',
  'Suma (€)': 'Betrag (€)',
  'Zadajte sumu': 'Geben Sie den Betrag ein',
  'Nesmie byť záporná': 'Darf nicht negativ sein',
  'Kto dostal pokutu': 'Wer hat das Bußgeld erhalten',
  'Neurčený / zatiaľ nevieme': 'Unbestimmt / noch unbekannt',
  'Meno a priezvisko': 'Vor- und Nachname',
  'Priestupok / dôvod': 'Verstoß / Grund',
  'napr. prekročenie rýchlosti, parkovanie': 'z. B. Geschwindigkeitsüberschreitung, Parken',
  'Číslo pokuty / spisu': 'Bußgeld-/Aktenzeichen',
  'Zaplatená': 'Bezahlt',
  'Dátum úhrady': 'Zahlungsdatum',
  'Prázdne = dnes': 'Leer = heute',
  'Hradil(a)': 'Bezahlt von',
  'Firma': 'Firma',
  'Vodič (zrazené / refakturované)': 'Fahrer (abgezogen / weiterberechnet)',
  'Poznámka': 'Notiz',
  'Pracovník zo zoznamu alebo iné meno': 'Mitarbeiter aus der Liste oder anderer Name',
  'Zo zoznamu pracovníkov': 'Aus der Mitarbeiterliste',
  'Iné meno (napísať)': 'Anderer Name (eingeben)',
  'Rezervácia bola uložená': 'Die Reservierung wurde gespeichert',
  'Vozidlo bolo rezervované': 'Das Fahrzeug wurde reserviert',
  'Rezerváciu sa nepodarilo uložiť': 'Die Reservierung konnte nicht gespeichert werden',
  'Upraviť rezerváciu': 'Reservierung bearbeiten',
  'Rezervovať vozidlo': 'Fahrzeug reservieren',
  'Rezervácia je na celé dni. Vozidlo sa pracovníkovi odovzdá neskôr – so zmluvou alebo interne.': 'Die Reservierung gilt für ganze Tage. Das Fahrzeug wird dem Mitarbeiter später übergeben – mit Vertrag oder intern.',
  'Rezervovať': 'Reservieren',
  'Pre koho': 'Für wen',
  'Vyberte zamestnanca alebo živnostníka…': 'Angestellten oder Selbstständigen wählen…',
  'Pri odovzdaní vozidla sa osoba pridá do zoznamu vodičov.': 'Bei der Übergabe des Fahrzeugs wird die Person in die Fahrerliste aufgenommen.',
  'Zadajte meno': 'Geben Sie einen Namen ein',
  'Účel / dôvod': 'Zweck / Grund',
  'napr. služobná cesta Viedeň, stavba Žilina…': 'z. B. Dienstreise Wien, Baustelle Žilina…',
  'Servisný záznam bol uložený': 'Der Serviceeintrag wurde gespeichert',
  'Servisný záznam bol vytvorený': 'Der Serviceeintrag wurde angelegt',
  'Servisný záznam sa nepodarilo uložiť': 'Der Serviceeintrag konnte nicht gespeichert werden',
  'Upraviť servisný záznam': 'Serviceeintrag bearbeiten',
  'Nový servisný záznam': 'Neuer Serviceeintrag',
  'Popis prác': 'Durchgeführte Arbeiten',
  'Stav km pri servise': 'Kilometerstand beim Service',
  'Cena (€)': 'Preis (€)',
  'Servis / dielňa': 'Werkstatt',
  'Číslo faktúry': 'Rechnungsnummer',
  'Plán ďalšej údržby': 'Plan der nächsten Wartung',
  'Ďalší servis – dátum': 'Nächster Service – Datum',
  'Ďalší servis – pri stave km': 'Nächster Service – bei Kilometerstand',
  'Pneumatiky {plate} boli uložené': 'Reifen von {plate} wurden gespeichert',
  'Pneumatiky sa nepodarilo uložiť': 'Die Reifen konnten nicht gespeichert werden',
  'Aktuálne namontovaná sada. Pri prezutí ju prepíšte – predchádzajúca zostane v histórii zmien vozidla.': 'Der aktuell montierte Satz. Beim Reifenwechsel überschreiben – der vorherige Satz bleibt im Änderungsverlauf des Fahrzeugs.',
  'Typ pneumatík': 'Reifentyp',
  'Nezadané': 'Nicht erfasst',
  'Namontované dňa': 'Montiert am',
  'napr. Michelin': 'z. B. Michelin',
  'Model / dezén': 'Modell / Profil',
  'napr. Alpin 6': 'z. B. Alpin 6',
  'Rozmer': 'Größe',
  'napr. 205/55 R16 91H': 'z. B. 205/55 R16 91H',
  'Známka bola uložená': 'Die Vignette wurde gespeichert',
  'Známka bola pridaná': 'Die Vignette wurde hinzugefügt',
  'Známku sa nepodarilo uložiť': 'Die Vignette konnte nicht gespeichert werden',
  'Upraviť diaľničnú známku': 'Autobahnvignette bearbeiten',
  'Nová diaľničná známka': 'Neue Autobahnvignette',
  'Typ známky': 'Vignettentyp',
  'Platná od': 'Gültig ab',
  'Platná do': 'Gültig bis',
  'Doplní sa podľa typu – skontrolujte podľa dokladu o kúpe': 'Wird nach dem Typ ausgefüllt – mit dem Kaufbeleg abgleichen',
  'Nesmie byť skôr ako „platná od“': 'Darf nicht vor „gültig ab“ liegen',
  'Číslo dokladu / referencia': 'Belegnummer / Referenz',
  'Evidencia vozidiel': 'Fahrzeugverwaltung',
  'Pripájanie…': 'Verbindung wird hergestellt…',
  'Živé aktualizácie zapnuté': 'Live-Aktualisierung aktiv',
  'Živé aktualizácie nedostupné – údaje sa obnovia pri ďalšej akcii': 'Live-Aktualisierung nicht verfügbar – Daten werden bei der nächsten Aktion aktualisiert',
  'Otvoriť menu': 'Menü öffnen',
  'Administrátor': 'Administrator',
  'Môj účet a heslo': 'Mein Konto und Passwort',
  'Odhlásiť sa': 'Abmelden',
  'Jazyk': 'Sprache',
  'Boli ste odhlásení': 'Sie wurden abgemeldet',
  'Preskočiť na obsah': 'Zum Inhalt springen',
  'Prehľad': 'Übersicht',
  'Vozidlá': 'Fahrzeuge',
  'Vodiči': 'Fahrer',
  'Rezervácie': 'Reservierungen',
  'Pridelenie': 'Zuweisungen',
  'Zmluvy': 'Verträge',
  'Plán údržby': 'Wartungsplan',
  'Servisy': 'Service',
  'Pneumatiky': 'Reifen',
  'Diaľničné známky': 'Autobahnvignetten',
  'Pokuty': 'Bußgelder',
  'Dokumenty': 'Dokumente',
  'GPS jazdy': 'GPS-Fahrten',
  'Audit log': 'Audit-Log',
  'Nastavenia': 'Einstellungen',
  'Zavrieť menu': 'Menü schließen',
  'Hlavná navigácia': 'Hauptnavigation',
  'Administrácia': 'Administration',
  'Neplatné pred {days} dňami': 'Seit {days} Tagen abgelaufen',
  'O {days} dní': 'In {days} Tagen',
  'Žiadne záznamy': 'Keine Einträge',
  '{from}–{to} z {total}': '{from}–{to} von {total}',
  'Počet záznamov na stránku': 'Einträge pro Seite',
  '{size} / stránka': '{size} / Seite',
  'Predchádzajúca strana': 'Vorherige Seite',
  'Ďalšia strana': 'Nächste Seite',
  'Hľadať…': 'Suchen…',
  'Vymazať hľadanie': 'Suche löschen',
  'Zavrieť': 'Schließen',
  'Potvrdiť': 'Bestätigen',
  'Heslo bolo zmenené': 'Das Passwort wurde geändert',
  'Heslo sa nepodarilo zmeniť': 'Das Passwort konnte nicht geändert werden',
  'Môj účet': 'Mein Konto',
  'Profil': 'Profil',
  'Používateľské meno': 'Benutzername',
  'Zmena hesla': 'Passwort ändern',
  'Súčasné heslo': 'Aktuelles Passwort',
  'Zadajte súčasné heslo': 'Geben Sie Ihr aktuelles Passwort ein',
  'Nové heslo': 'Neues Passwort',
  'Zadajte nové heslo': 'Geben Sie ein neues Passwort ein',
  'Aspoň 8 znakov': 'Mindestens 8 Zeichen',
  'Nové heslo znova': 'Neues Passwort wiederholen',
  'Heslá sa nezhodujú': 'Die Passwörter stimmen nicht überein',
  'Zmeniť heslo': 'Passwort ändern',
  'Nastavenie upozornení bolo uložené': 'Die Benachrichtigungseinstellungen wurden gespeichert',
  'E-mailová adresa bola odstránená – upozornenia nebudú chodiť': 'Die E-Mail-Adresse wurde entfernt – es werden keine Benachrichtigungen gesendet',
  'Nastavenie sa nepodarilo uložiť': 'Die Einstellungen konnten nicht gespeichert werden',
  'Skúšobný e-mail sa nepodarilo odoslať': 'Die Test-E-Mail konnte nicht gesendet werden',
  'Upozornenia e-mailom': 'E-Mail-Benachrichtigungen',
  'Upozornenie príde hneď, ako nastane – udalosti okamžite, blížiace sa termíny raz (kontrola každú hodinu cez deň).': 'Eine Benachrichtigung kommt, sobald etwas passiert – Ereignisse sofort, anstehende Termine einmalig (stündliche Prüfung tagsüber).',
  'Server zatiaľ nemá nastavené odosielanie e-mailov (SMTP v súbore backend\\.env). Nastavenie si môžete uložiť, e-maily začnú chodiť po jeho doplnení.': 'Auf dem Server ist der E-Mail-Versand noch nicht eingerichtet (SMTP in backend\\.env). Sie können die Einstellungen speichern; E-Mails kommen, sobald er eingerichtet ist.',
  'E-mailová adresa': 'E-Mail-Adresse',
  'meno@firma.sk': 'name@firma.de',
  'Zadajte platnú e-mailovú adresu': 'Geben Sie eine gültige E-Mail-Adresse ein',
  'Chcem dostávať': 'Ich möchte erhalten',
  'Poslať skúšobný e-mail': 'Test-E-Mail senden',
  'Prevzaté': 'Übernommen',
  'Požičané': 'Verliehen',
  'Km (začiatok → koniec)': 'Km (Start → Ende)',
  'Vrátiť': 'Zurückgeben',
  'Pridelenie vozidiel': 'Fahrzeugzuweisungen',
  'Kto má ktoré vozidlo a história výpožičiek': 'Wer hat welches Fahrzeug, und Ausleihverlauf',
  'Všetko': 'Alle',
  'Iba požičané': 'Nur verliehene',
  'Všetky vozidlá': 'Alle Fahrzeuge',
  'Všetci vodiči': 'Alle Fahrer',
  'Žiadne pridelenia nezodpovedajú filtru': 'Keine Zuweisungen entsprechen dem Filter',
  'Čas': 'Zeit',
  'Akcia': 'Aktion',
  'Záznam': 'Eintrag',
  'Zmena': 'Änderung',
  'Počítač / IP / MAC': 'Computer / IP / MAC',
  'Zobraziť všetky zmeny z tohto zariadenia': 'Alle Änderungen von diesem Gerät anzeigen',
  'Použité účty': 'Verwendete Konten',
  'len neúspešné prihlásenia': 'nur fehlgeschlagene Anmeldungen',
  'Záznamov': 'Einträge',
  'Prvý záznam': 'Erster Eintrag',
  'Posledný záznam': 'Letzter Eintrag',
  'Zmeny': 'Änderungen',
  'Kto, kedy, z ktorého počítača a čo zmenil – na úrovni jednotlivých polí': 'Wer hat wann, von welchem Computer aus, was geändert – Feld für Feld',
  'Export do CSV': 'Als CSV exportieren',
  'Zariadenia': 'Geräte',
  'Počítač, IP alebo MAC adresa…': 'Computer, IP- oder MAC-Adresse…',
  'Všetci': 'Alle',
  'Oblasť': 'Bereich',
  'Všetky': 'Alle',
  'ID záznamu': 'Eintrags-ID',
  'Pole': 'Feld',
  'napr. current_km': 'z. B. current_km',
  'Počítače, z ktorých sa v systéme niečo robilo. Zvýraznené sú zariadenia, z ktorých sa prihlásilo viac účtov. MAC adresu server zistí len pri počítačoch v tej istej sieti (VLAN) ako server.': 'Computer, von denen aus im System gearbeitet wurde. Hervorgehoben sind Geräte, von denen sich mehrere Konten angemeldet haben. Die MAC-Adresse ermittelt der Server nur bei Computern im selben Netzwerk (VLAN) wie der Server.',
  'Žiadne zariadenia nezodpovedajú filtru': 'Keine Geräte entsprechen dem Filter',
  'Žiadne záznamy nezodpovedajú filtru': 'Keine Einträge entsprechen dem Filter',
  'Detail zmeny': 'Änderungsdetail',
  'Zariadenie': 'Gerät',
  'IP adresa': 'IP-Adresse',
  'Názov počítača': 'Computername',
  'MAC adresa': 'MAC-Adresse',
  'nezistená': 'nicht ermittelt',
  'Odtlačok prehliadača': 'Browser-Fingerabdruck',
  'Pôvodná hodnota': 'Alter Wert',
  'Nová hodnota': 'Neuer Wert',
  'Vozidlo sa nenašlo': 'Fahrzeug nicht gefunden',
  'Späť na zoznam vozidiel': 'Zurück zur Fahrzeugliste',
  'Vozidlo bolo vyradené z prevádzky': 'Das Fahrzeug wurde ausgemustert',
  'Vyradiť': 'Ausmustern',
  'História zmien': 'Änderungsverlauf',
  'Vyradiť vozidlo': 'Fahrzeug ausmustern',
  'Vozidlo {plate} bude označené ako vyradené. História (servisy, dokumenty, jazdy) zostane zachovaná a stav je možné neskôr zmeniť úpravou vozidla.': 'Fahrzeug {plate} wird als ausgemustert markiert. Der Verlauf (Service, Dokumente, Fahrten) bleibt erhalten, und der Status kann später durch Bearbeiten des Fahrzeugs geändert werden.',
  'Aktuálne pridelenie': 'Aktuelle Zuweisung',
  'Vrátiť vozidlo': 'Fahrzeug zurückgeben',
  'Prideliť vodičovi': 'Einem Fahrer zuweisen',
  'Vozidlo je voľné.': 'Das Fahrzeug ist frei.',
  'Vozidlo nie je v aktívnej prevádzke, nie je možné ho prideliť.': 'Das Fahrzeug ist nicht im aktiven Betrieb und kann nicht zugewiesen werden.',
  'Údaje o vozidle': 'Fahrzeugdaten',
  'Značka a model': 'Marke und Modell',
  'Stav tachometra': 'Kilometerstand',
  'nezadané': 'nicht erfasst',
  'Posledná zmena': 'Letzte Änderung',
  'Súhrn': 'Zusammenfassung',
  'Náklady na servis spolu': 'Servicekosten gesamt',
  'Najazdené podľa GPS': 'Gefahren laut GPS',
  'Posledný servis': 'Letzter Service',
  'bez uvedenia servisu': 'ohne Werkstattangabe',
  'Poznámku sa nepodarilo uložiť': 'Die Notiz konnte nicht gespeichert werden',
  'Ukladá sa…': 'Wird gespeichert…',
  'Uložené': 'Gespeichert',
  'Chyba pri ukladaní': 'Fehler beim Speichern',
  'Poznámky k vozidlu sa ukladajú automaticky…': 'Notizen zum Fahrzeug werden automatisch gespeichert…',
  'Poznámky k vozidlu': 'Notizen zum Fahrzeug',
  'História pridelení': 'Zuweisungsverlauf',
  'Vozidlo zatiaľ nebolo nikomu pridelené': 'Das Fahrzeug wurde noch niemandem zugewiesen',
  'Servisná história': 'Serviceverlauf',
  'Náklady spolu: {cost}': 'Kosten gesamt: {cost}',
  'Nový záznam': 'Neuer Eintrag',
  'Žiadne servisné záznamy': 'Keine Serviceeinträge',
  'Zmazať servisný záznam': 'Serviceeintrag löschen',
  'Naozaj zmazať záznam zo dňa {serviceDate}?': 'Eintrag vom {serviceDate} wirklich löschen?',
  'Záznam bol zmazaný': 'Der Eintrag wurde gelöscht',
  'Žiadne dokumenty': 'Keine Dokumente',
  'GPS – mesačné záznamy': 'GPS – Monatseinträge',
  'Import knihy jázd': 'Fahrtenbuch importieren',
  'Žiadne importované mesiace': 'Keine importierten Monate',
  'V evidencii (bez vyradených)': 'Im Bestand (ohne ausgemusterte)',
  'Rok': 'Jahr',
  'Upraviť {plate}': '{plate} bearbeiten',
  'Evidencia vozového parku': 'Fuhrparkverwaltung',
  'Hľadať ŠPZ, značku, model, VIN…': 'Kennzeichen, Marke, Modell, FIN suchen…',
  'Všetky stavy': 'Alle Status',
  'Žiadne vozidlá nezodpovedajú filtru': 'Keine Fahrzeuge entsprechen dem Filter',
  'Vozidlo vrátené': 'Fahrzeug zurückgegeben',
  'Pripravená': 'Vorbereitet',
  'Ukončená': 'Beendet',
  'Prebieha': 'Läuft',
  'Číslo': 'Nummer',
  'Obdobie': 'Zeitraum',
  '{rate} / deň': '{rate} / Tag',
  'Vystavil': 'Ausgestellt von',
  'Stiahnuť (Word)': 'Herunterladen (Word)',
  'Zmluva {number} bola zmazaná': 'Vertrag {number} wurde gelöscht',
  'Zmluvy o nájme vozidiel – vygenerovaním zmluvy sa vozidlo zároveň pridelí pracovníkovi': 'Mietverträge für Fahrzeuge – mit dem Erstellen eines Vertrags wird das Fahrzeug zugleich dem Mitarbeiter zugewiesen',
  'Číslo zmluvy, meno, ŠPZ…': 'Vertragsnummer, Name, Kennzeichen…',
  'Všetci pracovníci': 'Alle Mitarbeiter',
  'Žiadne zmluvy nezodpovedajú filtru': 'Keine Verträge entsprechen dem Filter',
  'Zmazať zmluvu': 'Vertrag löschen',
  'Zmluva {number} ({driver}) a jej dokument budú zmazané. Ak vozidlo ešte nebolo vrátené, zruší sa aj pridelenie vytvorené touto zmluvou. Záznam zostane v audit logu.': 'Vertrag {number} ({driver}) und sein Dokument werden gelöscht. Wurde das Fahrzeug noch nicht zurückgegeben, wird auch die durch diesen Vertrag erstellte Zuweisung aufgehoben. Der Eintrag bleibt im Audit-Log.',
  'Stav vozového parku a úlohy vyžadujúce pozornosť': 'Fuhrparkstatus und Aufgaben, die Aufmerksamkeit erfordern',
  'Vozidlá v evidencii': 'Fahrzeuge im Bestand',
  'Aktívne vozidlá': 'Aktive Fahrzeuge',
  'V servise': 'In der Werkstatt',
  'Aktívni vodiči': 'Aktive Fahrer',
  'Požičané vozidlá': 'Verliehene Fahrzeuge',
  'Servisy do 30 dní': 'Service innerhalb von 30 Tagen',
  'Končiace dokumenty': 'Ablaufende Dokumente',
  'Končiace vodičáky': 'Ablaufende Führerscheine',
  'Známky končiace do 30 dní': 'Vignetten, die innerhalb von 30 Tagen ablaufen',
  'Nezaplatené pokuty': 'Unbezahlte Bußgelder',
  'Máte {alerts} upozornení na blížiace sa termíny (servisy, platnosť dokumentov, vodičských preukazov alebo diaľničných známok).': 'Sie haben {alerts} Hinweise auf anstehende Termine (Service, Gültigkeit von Dokumenten, Führerscheinen oder Autobahnvignetten).',
  'Plánované servisy': 'Geplanter Service',
  'Po termíne alebo do 30 dní / 1 500 km': 'Überfällig oder innerhalb von 30 Tagen / 1.500 km',
  'Žiadne blížiace sa servisy': 'Kein anstehender Service',
  'Po termíne': 'Überfällig',
  'o {daysLeft} dní': 'in {daysLeft} Tagen',
  'zostáva {kmLeft} km': 'noch {kmLeft} km',
  'Končiaca platnosť dokumentov': 'Ablaufende Dokumente',
  'Neplatné alebo končiace do 30 dní': 'Abgelaufen oder innerhalb von 30 Tagen ablaufend',
  'Žiadne končiace dokumenty': 'Keine ablaufenden Dokumente',
  'neplatné od {expiryDate}': 'abgelaufen am {expiryDate}',
  'Posledné zmeny': 'Letzte Änderungen',
  'Zatiaľ žiadna aktivita': 'Noch keine Aktivität',
  'systém': 'System',
  'Poistky, technické preukazy, protokoly a ďalšie súbory k vozidlám': 'Versicherungen, Zulassungsbescheinigungen, Protokolle und weitere Dateien zu den Fahrzeugen',
  'Názov, súbor, poznámka…': 'Titel, Datei, Notiz…',
  'Všetky typy': 'Alle Typen',
  'Platnosť': 'Gültigkeit',
  'Ľubovoľná': 'Beliebig',
  'Neplatné alebo končia do 30 dní': 'Abgelaufen oder innerhalb von 30 Tagen ablaufend',
  'Končia do 30 dní': 'Laufen innerhalb von 30 Tagen ab',
  'Neplatné': 'Abgelaufen',
  'Žiadne dokumenty nezodpovedajú filtru': 'Keine Dokumente entsprechen dem Filter',
  'os. č. {employeeId}': 'Pers.-Nr. {employeeId}',
  'Kontakt': 'Kontakt',
  'Vodičský preukaz': 'Führerschein',
  'Aktívny': 'Aktiv',
  'Neaktívny': 'Inaktiv',
  'Deaktivovať': 'Deaktivieren',
  'Aktivovať': 'Aktivieren',
  'Vodič bol deaktivovaný': 'Der Fahrer wurde deaktiviert',
  'Vodič bol aktivovaný': 'Der Fahrer wurde aktiviert',
  'Zamestnanci oprávnení viesť služobné vozidlá': 'Mitarbeiter, die Dienstfahrzeuge fahren dürfen',
  'Hľadať meno, os. číslo, oddelenie…': 'Name, Personalnummer, Abteilung suchen…',
  'Aktívni': 'Aktive',
  'Neaktívni': 'Inaktive',
  'Ľubovoľná platnosť VP': 'Beliebige Führerscheingültigkeit',
  'VP neplatný / končí do 30 dní': 'Führerschein abgelaufen / läuft innerhalb von 30 Tagen ab',
  'Žiadni vodiči nezodpovedajú filtru': 'Keine Fahrer entsprechen dem Filter',
  'Deaktivovať vodiča': 'Fahrer deaktivieren',
  'Aktivovať vodiča': 'Fahrer aktivieren',
  'Vodič {firstName} {lastName} nebude ponúkaný pri prideľovaní vozidiel. História zostane zachovaná.': 'Fahrer {firstName} {lastName} wird bei der Fahrzeugzuweisung nicht mehr angeboten. Der Verlauf bleibt erhalten.',
  'Vodič {firstName} {lastName} bude opäť dostupný na prideľovanie vozidiel.': 'Fahrer {firstName} {lastName} steht wieder für Fahrzeugzuweisungen zur Verfügung.',
  'Kto, kde a za koľko – prehľad nákladov na pokuty': 'Wer, wo und wie viel – Übersicht der Bußgeldkosten',
  'Všetky roky': 'Alle Jahre',
  'Pridať pokutu': 'Bußgeld hinzufügen',
  'Pokuty spolu {year}': 'Bußgelder gesamt {year}',
  'Pokuty spolu': 'Bußgelder gesamt',
  '{count} pokút': '{count} Bußgelder',
  'Zaplatila firma': 'Von der Firma bezahlt',
  'Zaplatil vodič': 'Vom Fahrer bezahlt',
  'Nezaplatené': 'Unbezahlt',
  '{unpaidCount} pokút čaká na úhradu': '{unpaidCount} Bußgelder warten auf Zahlung',
  'všetko uhradené': 'alles bezahlt',
  'Pokuty podľa mesiacov {year}': 'Bußgelder nach Monat {year}',
  'Suma v € podľa dátumu priestupku': 'Betrag in € nach Datum des Verstoßes',
  'Podľa krajiny': 'Nach Land',
  'Podľa osoby': 'Nach Person',
  'Podľa vozidla': 'Nach Fahrzeug',
  'Ostatné ({rest})': 'Sonstige ({rest})',
  'bez pokút': 'keine Bußgelder',
  'Pokuta je označená ako zaplatená': 'Das Bußgeld ist als bezahlt markiert',
  'Kto': 'Wer',
  'neurčený': 'unbestimmt',
  'Priestupok': 'Verstoß',
  'č. {reference}': 'Nr. {reference}',
  'Suma': 'Betrag',
  'Úhrada': 'Zahlung',
  'Zaplatené {paidDate}': 'Bezahlt am {paidDate}',
  'Zaplatené': 'Bezahlt',
  'vodič': 'Fahrer',
  'firma': 'Firma',
  'Označiť ako zaplatenú (firma)': 'Als bezahlt markieren (Firma)',
  'Označiť ako zaplatenú': 'Als bezahlt markieren',
  'Meno, priestupok, číslo…': 'Name, Verstoß, Nummer…',
  'Všetky krajiny': 'Alle Länder',
  '{count} pokút · spolu {sum}': '{count} Bußgelder · gesamt {sum}',
  'Žiadne pokuty nezodpovedajú filtru': 'Keine Bußgelder entsprechen dem Filter',
  'Zmazať pokutu': 'Bußgeld löschen',
  'Zmazať pokutu {amount} ({country}, {fineDate})?': 'Bußgeld {amount} ({country}, {fineDate}) löschen?',
  'Pokuta bola zmazaná': 'Das Bußgeld wurde gelöscht',
  'Nastavte si vlastné heslo': 'Legen Sie Ihr eigenes Passwort fest',
  'Účet {username} má dočasné heslo. Pred pokračovaním si zvoľte nové heslo, ktoré poznáte iba vy.': 'Das Konto {username} hat ein vorläufiges Passwort. Wählen Sie vor dem Fortfahren ein neues Passwort, das nur Sie kennen.',
  'Dočasné heslo': 'Vorläufiges Passwort',
  'Zadajte dočasné heslo': 'Geben Sie das vorläufige Passwort ein',
  'Nové heslo musí byť iné ako dočasné': 'Das neue Passwort muss sich vom vorläufigen unterscheiden',
  'Uložiť heslo a pokračovať': 'Passwort speichern und fortfahren',
  'Dátum jazdy': 'Fahrtdatum',
  'ŠPZ vozidla': 'Kennzeichen',
  'Čas začiatku': 'Startzeit',
  'Čas konca': 'Endzeit',
  'Odkiaľ': 'Von',
  'Kam': 'Nach',
  'Vzdialenosť (km)': 'Entfernung (km)',
  'Doba jazdy (min)': 'Fahrtdauer (min)',
  'Vodič (meno)': 'Fahrer (Name)',
  'Účel jazdy': 'Fahrtzweck',
  'Číslo jazdy': 'Fahrtnummer',
  'GPSPOLOHA.SK – kniha jázd': 'GPSPOLOHA.SK – Fahrtenbuch',
  'Všeobecná tabuľka': 'Allgemeine Tabelle',
  'Nerozpoznaný': 'Nicht erkannt',
  'Mesačné knihy jázd z GPS systému – jeden záznam za vozidlo a mesiac': 'Monatliche Fahrtenbücher aus dem GPS-System – ein Eintrag pro Fahrzeug und Monat',
  'Mesačné záznamy': 'Monatseinträge',
  'Nový import': 'Neuer Import',
  'Súbory sa nepodarilo spracovať': 'Die Dateien konnten nicht verarbeitet werden',
  '{rejected} súbor(ov) nie je vo formáte XLSX': '{rejected} Datei(en) sind nicht im XLSX-Format',
  'Importované mesačné záznamy: {months}': 'Importierte Monatseinträge: {months}',
  'Nebol importovaný žiadny mesačný záznam': 'Es wurde kein Monatseintrag importiert',
  'Import zlyhal': 'Import fehlgeschlagen',
  'Import dokončený': 'Import abgeschlossen',
  'Súbory: {count}': 'Dateien: {count}',
  'Z toho nahradené': 'Davon ersetzt',
  'Importované jazdy': 'Importierte Fahrten',
  'Chybné riadky': 'Fehlerhafte Zeilen',
  'Novo založené vozidlá (doplňte značku a model): {cars}': 'Neu angelegte Fahrzeuge (Marke und Modell ergänzen): {cars}',
  'Novo založení vodiči: {drivers}': 'Neu angelegte Fahrer: {drivers}',
  'Stav km aktualizovaný podľa tachometra: {cars}': 'Kilometerstand laut Tacho aktualisiert: {cars}',
  'Importovať ďalšie súbory': 'Weitere Dateien importieren',
  'Zobraziť mesačné záznamy': 'Monatseinträge anzeigen',
  'Pridať ďalšie súbory (pretiahnite sem alebo kliknite)': 'Weitere Dateien hinzufügen (hierher ziehen oder klicken)',
  'Pretiahnite sem mesačné knihy jázd (XLSX) alebo kliknite pre výber': 'Monatliche Fahrtenbücher (XLSX) hierher ziehen oder zum Auswählen klicken',
  'Export „mesačná kniha jázd“ z GPSPOLOHA.SK (súbor KJ_…) – jeden súbor za vozidlo a mesiac, vozidlo sa rozpozná z hlavičky. Naraz môžete nahrať viac vozidiel aj mesiacov. Z každého vznikne jeden mesačný záznam s kilometrami a navštívenými miestami; opätovný import toho istého mesiaca ho nahradí. Pred importom uvidíte náhľad; nič sa neuloží, kým import nepotvrdíte.': 'Export des „Monatsfahrtenbuchs“ aus GPSPOLOHA.SK (Datei KJ_…) – eine Datei pro Fahrzeug und Monat; das Fahrzeug wird aus dem Dateikopf erkannt. Sie können mehrere Fahrzeuge und Monate auf einmal hochladen. Aus jeder Datei entsteht ein Monatseintrag mit Kilometern und besuchten Orten; ein erneuter Import desselben Monats ersetzt ihn. Vor dem Import sehen Sie eine Vorschau; gespeichert wird erst, wenn Sie den Import bestätigen.',
  '1. Súbory': '1. Dateien',
  '{files} súbor(ov) · {months} mesačných záznamov · {totalRows} jázd': '{files} Datei(en) · {months} Monatseinträge · {totalRows} Fahrten',
  'Spracovávam…': 'Wird verarbeitet…',
  'Začať znova': 'Neu beginnen',
  '{rows} jázd': '{rows} Fahrten',
  'Mapovanie stĺpcov': 'Spaltenzuordnung',
  'Pre súbory vo formáte bežnej tabuľky. Stĺpce sa rozpoznali automaticky – skontrolujte ich.': 'Für Dateien im allgemeinen Tabellenformat. Die Spalten wurden automatisch erkannt – bitte prüfen Sie sie.',
  '— nepoužiť —': '— nicht verwenden —',
  'Aktualizovať náhľad': 'Vorschau aktualisieren',
  'Chýbajú povinné stĺpce: {columns}': 'Pflichtspalten fehlen: {columns}',
  '2. Kontrola údajov': '2. Datenprüfung',
  'Nahradia existujúce': 'Ersetzen bestehende',
  'Jázd na import': 'Zu importierende Fahrten',
  'V súboroch sú vozidlá alebo vodiči, ktorí ešte nie sú v evidencii': 'Die Dateien enthalten Fahrzeuge oder Fahrer, die noch nicht erfasst sind',
  'Vozidlá: {cars}': 'Fahrzeuge: {cars}',
  'Vodiči: {drivers}': 'Fahrer: {drivers}',
  'Automaticky ich založiť (inak sa ich jazdy preskočia)': 'Automatisch anlegen (sonst werden ihre Fahrten übersprungen)',
  'V súboroch sa nenašli žiadne jazdy': 'In den Dateien wurden keine Fahrten gefunden',
  'Mesiace označené „nahradí“ už v evidencii sú – ich doterajšie jazdy sa nahradia jazdami z nahraného súboru.': 'Mit „ersetzt“ markierte Monate sind bereits erfasst – ihre bisherigen Fahrten werden durch die Fahrten aus der hochgeladenen Datei ersetzt.',
  'Jazdy v súboroch ({count})': 'Fahrten in den Dateien ({count})',
  'Zobrazených prvých {shown} z {total} jázd.': 'Angezeigt werden die ersten {shown} von {total} Fahrten.',
  'Importuje sa {months} mesačných záznamov ({rides} jázd)': 'Es werden {months} Monatseinträge importiert ({rides} Fahrten)',
  ' bez neznámych vozidiel': ' ohne unbekannte Fahrzeuge',
  'Potvrdiť import': 'Import bestätigen',
  'Jázd': 'Fahrten',
  'nahradí existujúci': 'ersetzt bestehenden',
  'nový': 'neu',
  'nové vozidlo': 'neues Fahrzeug',
  'Nahradené': 'Ersetzt',
  'Nové': 'Neu',
  'Súbor / riadok': 'Datei / Zeile',
  'Riadok': 'Zeile',
  'nové': 'neu',
  'OK': 'OK',
  '{count} mesačných záznamov · spolu {sum}': '{count} Monatseinträge · gesamt {sum}',
  'Žiadne mesačné záznamy': 'Keine Monatseinträge',
  'Nahrajte mesačnú knihu jázd v záložke „Nový import“.': 'Laden Sie ein Monatsfahrtenbuch im Reiter „Neuer Import“ hoch.',
  'Zmazať mesačný záznam': 'Monatseintrag löschen',
  'Zmazať záznam {plate} za {month} so všetkými {rideCount} jazdami? Mesiac potom môžete importovať znova.': 'Eintrag {plate} für {month} mit allen {rideCount} Fahrten löschen? Den Monat können Sie danach erneut importieren.',
  'Zmazaný mesačný záznam ({deleted} jázd)': 'Monatseintrag gelöscht ({deleted} Fahrten)',
  'Mesačný záznam sa nenašiel': 'Monatseintrag nicht gefunden',
  '{brand} {model} · mesačná kniha jázd': '{brand} {model} · Monatsfahrtenbuch',
  'Najazdené km': 'Gefahrene km',
  'Služobne km': 'Dienstliche km',
  'Súkromne km': 'Private km',
  'Čas jazdy': 'Fahrzeit',
  'Importované': 'Importiert',
  'Navštívené miesta (od najčastejších)': 'Besuchte Orte (häufigste zuerst)',
  'Jazdy v mesiaci': 'Fahrten im Monat',
  'Žiadne jazdy': 'Keine Fahrten',
  'Prihlásenie sa nepodarilo': 'Anmeldung fehlgeschlagen',
  'Prihlásenie': 'Anmeldung',
  'Interný systém evidencie vozového parku': 'Internes System zur Fuhrparkverwaltung',
  'Zadajte používateľské meno': 'Geben Sie Ihren Benutzernamen ein',
  'Heslo': 'Passwort',
  'Zadajte heslo': 'Geben Sie Ihr Passwort ein',
  'Prihlásiť sa': 'Anmelden',
  'V poriadku': 'In Ordnung',
  'Blíži sa': 'Rückt näher',
  'Čoskoro': 'Bald',
  '{daysLeft} dní po termíne': '{daysLeft} Tage überfällig',
  'prekročené o {kmLeft} km': 'um {kmLeft} km überschritten',
  'bez plánu – zadať servis': 'kein Plan – Service erfassen',
  '{title}: {label}. Posledný {lastDate}, ďalší {next}. {remaining}': '{title}: {label}. Letzter {lastDate}, nächster {next}. {remaining}',
  '{title}: {label}': '{title}: {label}',
  'ďalší: {next}': 'nächster: {next}',
  'Ako ďaleko je každé vozidlo od servisu a od STK / EK – podľa dátumu alebo kilometrov, čo nastane skôr': 'Wie weit jedes Fahrzeug vom Service und von der HU/AU (STK / EK) entfernt ist – nach Datum oder Kilometern, je nachdem, was zuerst eintritt',
  'Zapísať servis': 'Service erfassen',
  'Bez plánu': 'Ohne Plan',
  'Žiadne vozidlá v prevádzke': 'Keine Fahrzeuge im Betrieb',
  'STK / EK': 'HU/AU (STK / EK)',
  'Pás ukazuje, koľko z intervalu od posledného servisu už uplynulo. Červená = do 30 dní alebo 1 500 km, príp. po termíne; oranžová = viac ako 75 % intervalu. Plán sa berie z posledného servisného záznamu s vyplneným „ďalší servis“ (STK / EK z typu „Kontrola / STK / EK“).': 'Der Balken zeigt, wie viel vom Intervall seit dem letzten Service bereits verstrichen ist. Rot = innerhalb von 30 Tagen oder 1.500 km bzw. überfällig; Orange = mehr als 75 % des Intervalls. Der Plan stammt aus dem letzten Serviceeintrag mit ausgefülltem „nächster Service“ (HU/AU aus dem Typ „Prüfung / STK / EK“).',
  'Stránka sa nenašla': 'Seite nicht gefunden',
  'Požadovaná stránka neexistuje.': 'Die angeforderte Seite existiert nicht.',
  'Späť na prehľad': 'Zurück zur Übersicht',
  'Rezervácie vozidiel': 'Fahrzeugreservierungen',
  'Kalendár voľných, rezervovaných a požičaných vozidiel': 'Kalender freier, reservierter und verliehener Fahrzeuge',
  'Zrušiť rezerváciu': 'Reservierung stornieren',
  'Zrušiť rezerváciu {plate} pre {person} ({dateFrom} – {dateTo})?': 'Reservierung von {plate} für {person} ({dateFrom} – {dateTo}) stornieren?',
  ' Vozidlo už bolo odovzdané – pridelenie zostane, ukončite ho v Pridelení.': ' Das Fahrzeug wurde bereits übergeben – die Zuweisung bleibt bestehen; beenden Sie sie unter Zuweisungen.',
  'Rezervácia bola zrušená': 'Die Reservierung wurde storniert',
  'Presun bol vrátený – {message}': 'Verschiebung rückgängig gemacht – {message}',
  'Rezervácia presunutá – {message}': 'Reservierung verschoben – {message}',
  'Späť': 'Rückgängig',
  'Rezerváciu sa nepodarilo presunúť': 'Die Reservierung konnte nicht verschoben werden',
  'Rezerváciu nemožno presunúť do minulosti': 'Eine Reservierung kann nicht in die Vergangenheit verschoben werden',
  'Vozidlo je v tomto období už rezervované pre {label}': 'Das Fahrzeug ist in diesem Zeitraum bereits für {label} reserviert',
  'Rezervované': 'Reserviert',
  'bez plánovaného konca': 'ohne geplantes Ende',
  'Predchádzajúci mesiac': 'Vorheriger Monat',
  'Nasledujúci mesiac': 'Nächster Monat',
  'Dnes': 'Heute',
  'voľné': 'frei',
  'rezervované': 'reserviert',
  'požičané': 'verliehen',
  '{plate}, {day}: voľné – kliknutím rezervujete': '{plate}, {day}: frei – zum Reservieren klicken',
  ' – potiahnutím presuniete, za okraj zmeníte dĺžku': ' – zum Verschieben ziehen, am Rand ziehen, um die Dauer zu ändern',
  'Žiadne aktívne vozidlá': 'Keine aktiven Fahrzeuge',
  'Kliknite na voľný deň pre novú rezerváciu, na rezervovaný pre úpravu. Rezerváciu môžete myšou potiahnuť na iné dni, potiahnutím okraja zmeníte jej dĺžku (ukončené rezervácie sa presunúť nedajú). Požičané = odovzdané so zmluvou alebo interne (Pridelenie).': 'Klicken Sie auf einen freien Tag für eine neue Reservierung, auf einen reservierten zum Bearbeiten. Eine Reservierung können Sie mit der Maus auf andere Tage ziehen oder am Rand ihre Dauer ändern (beendete Reservierungen lassen sich nicht verschieben). Verliehen = mit Vertrag oder intern übergeben (Zuweisungen).',
  'mimo zoznamu pracovníkov': 'nicht in der Mitarbeiterliste',
  'Odovzdané · zmluva {number}': 'Übergeben · Vertrag {number}',
  'Odovzdané interne': 'Intern übergeben',
  'Odovzdať': 'Übergeben',
  'Aktuálne a nadchádzajúce rezervácie': 'Aktuelle und kommende Reservierungen',
  'Žiadne nadchádzajúce rezervácie': 'Keine kommenden Reservierungen',
  '{person} bol(a) pridaný(á) do zoznamu vodičov': '{person} wurde in die Fahrerliste aufgenommen',
  'Vozidlo {plate} bolo interne požičané – {person}': 'Fahrzeug {plate} wurde intern verliehen – {person}',
  'Vozidlo sa nepodarilo odovzdať': 'Das Fahrzeug konnte nicht übergeben werden',
  'Odovzdať vozidlo': 'Fahrzeug übergeben',
  'So zmluvou o nájme': 'Mit Mietvertrag',
  'Pre živnostníka alebo externú osobu. Otvorí sa predvyplnená zmluva (Word) a vozidlo sa pridelí.': 'Für Selbstständige oder externe Personen. Ein vorausgefüllter Vertrag (Word) wird geöffnet und das Fahrzeug zugewiesen.',
  'Interne, bez zmluvy': 'Intern, ohne Vertrag',
  'Zamestnanec firmy – vozidlo sa iba pridelí na rezervované obdobie (Pridelenie).': 'Mitarbeiter der Firma – das Fahrzeug wird nur für den reservierten Zeitraum zugewiesen (Zuweisungen).',
  'Termín': 'Termin',
  'Pri stave km': 'Bei Kilometerstand',
  'Servisy a údržba': 'Service und Wartung',
  'Servisné záznamy, náklady a plánovaná údržba': 'Serviceeinträge, Kosten und geplante Wartung',
  'Servisné záznamy': 'Serviceeinträge',
  'Plánovaná údržba': 'Geplante Wartung',
  'Vozidlá, ktorých posledný servisný záznam plánuje ďalšiu údržbu do 30 dní alebo do 1 500 km (prípadne už po termíne).': 'Fahrzeuge, deren letzter Serviceeintrag die nächste Wartung innerhalb von 30 Tagen oder 1.500 km vorsieht (oder bereits überfällig).',
  'Žiadna blížiaca sa údržba': 'Keine anstehende Wartung',
  'Popis, servis, faktúra…': 'Beschreibung, Werkstatt, Rechnung…',
  'Náklady za vybrané záznamy: {sum}': 'Kosten der ausgewählten Einträge: {sum}',
  'Naozaj zmazať servisný záznam {plate} zo dňa {serviceDate}?': 'Serviceeintrag von {plate} vom {serviceDate} wirklich löschen?',
  'Používateľské účty a vzhľad aplikácie': 'Benutzerkonten und Erscheinungsbild der App',
  'Používatelia': 'Benutzer',
  'Vzhľad a firma': 'Erscheinungsbild und Firma',
  'Deaktivovaný': 'Deaktiviert',
  'Vytvorený': 'Erstellt',
  'Administrátor vidí audit log a spravuje používateľov aj vzhľad. Bežný používateľ spravuje vozidlá, vodičov, servisy, dokumenty a importy.': 'Ein Administrator sieht das Audit-Log und verwaltet Benutzer und das Erscheinungsbild. Ein normaler Benutzer verwaltet Fahrzeuge, Fahrer, Service, Dokumente und Importe.',
  'Nový používateľ': 'Neuer Benutzer',
  'Deaktivovať používateľa': 'Benutzer deaktivieren',
  'Aktivovať používateľa': 'Benutzer aktivieren',
  'Používateľ {username} sa nebude môcť prihlásiť. Jeho záznamy v audit logu zostanú zachované.': 'Benutzer {username} kann sich nicht mehr anmelden. Die Einträge im Audit-Log bleiben erhalten.',
  'Používateľ {username} sa bude opäť môcť prihlásiť.': 'Benutzer {username} kann sich wieder anmelden.',
  'Používateľ uložený, heslo bolo zmenené': 'Benutzer gespeichert, das Passwort wurde geändert',
  'Používateľ uložený': 'Benutzer gespeichert',
  'Používateľ bol vytvorený': 'Der Benutzer wurde angelegt',
  'Používateľa sa nepodarilo uložiť': 'Der Benutzer konnte nicht gespeichert werden',
  'Upraviť používateľa {username}': 'Benutzer {username} bearbeiten',
  'Aspoň 3 znaky': 'Mindestens 3 Zeichen',
  'Iba písmená bez diakritiky, číslice, . _ -': 'Nur Buchstaben ohne Akzente, Ziffern, . _ -',
  'Vlastnú rolu nie je možné zmeniť': 'Die eigene Rolle kann nicht geändert werden',
  'Vyplňte iba pri nastavení nového hesla (používateľ si ho pri prihlásení zmení)': 'Nur ausfüllen, um ein neues Passwort festzulegen (der Benutzer ändert es bei der Anmeldung)',
  'Účet je aktívny': 'Das Konto ist aktiv',
  'Vyberte obrázok (PNG, SVG, JPG)': 'Wählen Sie ein Bild (PNG, SVG, JPG)',
  'Logo môže mať najviac 500 kB': 'Das Logo darf höchstens 500 kB groß sein',
  'Nastavenie vzhľadu bolo uložené': 'Die Einstellungen zum Erscheinungsbild wurden gespeichert',
  'Firma a vzhľad': 'Firma und Erscheinungsbild',
  'Zobrazuje sa na prihlasovacej stránke, v menu a v titulku okna': 'Wird auf der Anmeldeseite, im Menü und im Fenstertitel angezeigt',
  'Názov spoločnosti / aplikácie': 'Firmen-/App-Name',
  'Hex kód farby': 'Hex-Farbcode',
  'Bez loga': 'Kein Logo',
  'Vybrať obrázok': 'Bild auswählen',
  'Odobrať': 'Entfernen',
  'PNG alebo SVG s priehľadným pozadím, max. 500 kB.': 'PNG oder SVG mit transparentem Hintergrund, max. 500 kB.',
  'Uložiť nastavenie': 'Einstellungen speichern',
  'Náhľad tlačidiel': 'Schaltflächenvorschau',
  'Hlavná akcia': 'Hauptaktion',
  'Vedľajšia akcia': 'Nebenaktion',
  'Zvýraznená položka menu': 'Hervorgehobener Menüeintrag',
  'Aké pneumatiky má ktoré vozidlo práve namontované': 'Welche Reifen jedes Fahrzeug gerade montiert hat',
  'Zimné obdobie: {count} vozidlo má letné pneumatiky. Pri snehu alebo ľade sú na Slovensku povinné zimné.': 'Winterzeit: {count} Fahrzeug hat Sommerreifen. Bei Schnee oder Eis sind in der Slowakei Winterreifen Pflicht.',
  'Zimné obdobie: {count} vozidlá majú letné pneumatiky. Pri snehu alebo ľade sú na Slovensku povinné zimné.': 'Winterzeit: {count} Fahrzeuge haben Sommerreifen. Bei Schnee oder Eis sind in der Slowakei Winterreifen Pflicht.',
  'Žiadne vozidlá': 'Keine Fahrzeuge',
  'Upraviť pneumatiky': 'Reifen bearbeiten',
  'Upraviť pneumatiky {plate}': 'Reifen von {plate} bearbeiten',
  'Značka nezadaná': 'Marke nicht erfasst',
  'namontované {date}': 'montiert {date}',
  'Zadať pneumatiky': 'Reifen erfassen',
  'letné v zimnom období': 'Sommerreifen im Winter',
  'Oficiálny predaj známok – {shopName}': 'Offizieller Vignettenverkauf – {shopName}',
  'Kúpiť': 'Kaufen',
  'Elektronické známky v krajinách EÚ, kde sú pre osobné autá povinné': 'Elektronische Vignetten in EU-Ländern, in denen sie für Pkw Pflicht sind',
  'Pridať známku': 'Vignette hinzufügen',
  'Prehľad vozidiel': 'Fahrzeugübersicht',
  'Všetky známky': 'Alle Vignetten',
  '{name}: platná do {validTo} – pridať ďalšiu': '{name}: gültig bis {validTo} – weitere hinzufügen',
  'Pridať známku – {name}': 'Vignette hinzufügen – {name}',
  '{name}: {validFrom} – {validTo}. Kliknutím pridáte ďalšiu.': '{name}: {validFrom} – {validTo}. Klicken, um eine weitere hinzuzufügen.',
  'neplatná': 'abgelaufen',
  'o {days} dní': 'in {days} Tagen',
  'platná': 'gültig',
  'končí do {WARNDAYS} dní': 'läuft innerhalb von {WARNDAYS} Tagen ab',
  'Kliknutím na políčko pridáte známku (obnovenie začne dňom po skončení aktuálnej). „Kúpiť“ otvorí oficiálny štátny e-shop.': 'Klicken Sie auf ein Feld, um eine Vignette hinzuzufügen (eine Verlängerung beginnt am Tag nach Ablauf der aktuellen). „Kaufen“ öffnet den offiziellen staatlichen Onlineshop.',
  'Doklad': 'Beleg',
  'Platné dnes': 'Heute gültig',
  'Končia do {WARNDAYS} dní': 'Laufen innerhalb von {WARNDAYS} Tagen ab',
  '{count} známok · spolu {sum}': '{count} Vignetten · gesamt {sum}',
  'Žiadne známky nezodpovedajú filtru': 'Keine Vignetten entsprechen dem Filter',
  'Zmazať známku': 'Vignette löschen',
  'Zmazať známku {country} pre {plate} ({validFrom} – {validTo})?': 'Vignette {country} für {plate} ({validFrom} – {validTo}) löschen?',
  'Známka bola zmazaná': 'Die Vignette wurde gelöscht',
  'Predané': 'Verkauft',
  'Vyradené': 'Ausgemustert',
  'Benzín': 'Benzin',
  'Nafta': 'Diesel',
  'Elektro': 'Elektro',
  'Hybrid': 'Hybrid',
  'Údržba': 'Wartung',
  'Oprava': 'Reparatur',
  'Kontrola / STK / EK': 'Prüfung / HU/AU (STK / EK)',
  'Ostatné': 'Sonstiges',
  'Odovzdávací protokol': 'Übergabeprotokoll',
  'Poistenie': 'Versicherung',
  'Technický preukaz': 'Zulassungsbescheinigung',
  'Fotografie': 'Fotos',
  'Zamestnanec': 'Angestellter',
  'Živnostník': 'Selbstständiger',
  'Letné': 'Sommer',
  'L': 'S',
  'Zimné': 'Winter',
  'Z': 'W',
  'Celoročné': 'Ganzjahres',
  'C': 'G',
  'Slovensko': 'Slowakei',
  'Česko': 'Tschechien',
  'Rakúsko': 'Österreich',
  'Maďarsko': 'Ungarn',
  'Poľsko': 'Polen',
  'Nemecko': 'Deutschland',
  'Slovinsko': 'Slowenien',
  'Chorvátsko': 'Kroatien',
  'Taliansko': 'Italien',
  'Francúzsko': 'Frankreich',
  'Švajčiarsko': 'Schweiz',
  'Belgicko': 'Belgien',
  'Holandsko': 'Niederlande',
  'Luxembursko': 'Luxemburg',
  'Dánsko': 'Dänemark',
  'Švédsko': 'Schweden',
  'Nórsko': 'Norwegen',
  'Fínsko': 'Finnland',
  'Španielsko': 'Spanien',
  'Portugalsko': 'Portugal',
  'Rumunsko': 'Rumänien',
  'Bulharsko': 'Bulgarien',
  'Srbsko': 'Serbien',
  'Grécko': 'Griechenland',
  'Litva': 'Litauen',
  'Lotyšsko': 'Lettland',
  'Estónsko': 'Estland',
  'Írsko': 'Irland',
  'Spojené kráľovstvo': 'Vereinigtes Königreich',
  'Ukrajina': 'Ukraine',
  '1-dňová': '1 Tag',
  'víkendová': 'Wochenende',
  '7-dňová / týždenná': '7 Tage / Woche',
  '10-dňová': '10 Tage',
  'mesačná / 30-dňová': 'Monat / 30 Tage',
  '2-mesačná': '2 Monate',
  'štvrťročná / 90-dňová': 'Quartal / 90 Tage',
  'ročná': 'Jahr',
  'regionálna (župná) ročná': 'regional (Kreis), Jahr',
  'Pridelenia': 'Zuweisungen',
  'Vytvorenie': 'Erstellung',
  'Zmazanie': 'Löschung',
  'Neúspešné prihlásenie': 'Fehlgeschlagene Anmeldung',
  'Import': 'Import',
  'Spolu za {days} dni: {total} bez DPH': 'Gesamt für {days} Tage: {total} ohne MwSt.',
  'Spolu za {days} dní: {total} bez DPH': 'Gesamt für {days} Tage: {total} ohne MwSt.',
  'Domov': 'Startseite',
  'Prepnúť na štandardné zobrazenie': 'Zur Standardansicht wechseln',
  'Prepnúť na zobrazenie s dlaždicami': 'Zur Kachelansicht wechseln',
  'Náklady': 'Kosten',
  'Kategória': 'Kategorie',
  'Priemer na vozidlo': 'Durchschnitt pro Fahrzeug',
  'Vitajte, {name}': 'Willkommen, {name}',
  'Vyberte, s čím chcete pracovať': 'Wählen Sie, womit Sie arbeiten möchten',
  'Opravy': 'Reparaturen',
  'Celkové náklady vozového parku a náklady jednotlivých vozidiel': 'Gesamtkosten des Fuhrparks und Kosten der einzelnen Fahrzeuge',
  'Pripravujeme:': 'In Vorbereitung:',
  'Spolu': 'Gesamt',
  'Najviac opráv': 'Meiste Reparaturen',
  '{count}×': '{count}×',
  'Údržba, STK, pneu': 'Wartung, HU, Reifen',
  'Známky': 'Vignetten',
  '€ / km': '€ / km',
  'Najvyšší náklad na km': 'Höchste Kosten pro km',
  'Spotreba': 'Verbrauch',
  'Náklady spolu {year}': 'Gesamtkosten {year}',
  'Náklady spolu': 'Gesamtkosten',
  '{count} položiek': '{count} Posten',
  '{count} opráv': '{count} Reparaturen',
  '{count} vozidiel s nákladmi': '{count} Fahrzeuge mit Kosten',
  '{count} opráv, {amount}': '{count} Reparaturen, {amount}',
  'žiadne opravy': 'keine Reparaturen',
  'Náklady podľa mesiacov {year}': 'Kosten nach Monaten {year}',
  'Podľa kategórií': 'Nach Kategorien',
  'Porovnanie vozidiel': 'Fahrzeugvergleich',
  'Kliknite na vozidlo pre detail jeho nákladov': 'Klicken Sie auf ein Fahrzeug, um seine Kosten im Detail zu sehen',
  'Detail': 'Detail',
  'Karta vozidla': 'Fahrzeugkarte',
  'priemer vozidla vo vozovom parku {amount}': 'Fuhrpark-Durchschnitt pro Fahrzeug {amount}',
  'podľa GPS kníh jázd': 'laut GPS-Fahrtenbüchern',
  'Náklad na km': 'Kosten pro km',
  'priemer vozového parku {value} €': 'Fuhrpark-Durchschnitt {value} €',
  'Položky nákladov': 'Kostenposten',
  'Žiadne náklady v tomto období': 'Keine Kosten in diesem Zeitraum',
  'Posledná poloha (GPS)': 'Letzte Position (GPS)',
  'Stiahnuté z GPS – vozidlá: {cars}, jazdy: {rides}': 'Von GPS geladen – Fahrzeuge: {cars}, Fahrten: {rides}',
  'Sťahovanie z GPS zlyhalo': 'GPS-Download fehlgeschlagen',
  ' a ': ' und ',
  'Automatické sťahovanie z GPSPOLOHA': 'Automatischer Download von GPSPOLOHA',
  'Každý deň o {hours} sa stiahnu jazdy, kilometre a poloha všetkých vozidiel.': 'Täglich um {hours} werden Fahrten, Kilometerstand und Position aller Fahrzeuge geladen.',
  'Nie je zapnuté – na serveri chýba premenná GPSPOLOHA_API_KEY.': 'Nicht aktiviert – auf dem Server fehlt die Variable GPSPOLOHA_API_KEY.',
  'Stiahnuť teraz': 'Jetzt laden',
  'Naposledy:': 'Zuletzt:',
  'ručne': 'manuell',
  'automaticky': 'automatisch',
  'aktualizované vozidlá: {cars} z {total}, jazdy: {rides}': 'aktualisierte Fahrzeuge: {cars} von {total}, Fahrten: {rides}',
  'Nie sú v GPSPOLOHA: {plates}': 'Nicht in GPSPOLOHA: {plates}',
  'Tankovanie bolo uložené': 'Tankvorgang gespeichert',
  'Tankovanie bolo pridané': 'Tankvorgang hinzugefügt',
  'Tankovanie sa nepodarilo uložiť': 'Der Tankvorgang konnte nicht gespeichert werden',
  'Upraviť tankovanie': 'Tankvorgang bearbeiten',
  'Nové tankovanie': 'Neuer Tankvorgang',
  'Pre tankovanie zaplatené v hotovosti alebo inou kartou – tankovanie zo Shell kariet sa importuje.': 'Für bar oder mit einer anderen Karte bezahlte Tankvorgänge – Tankvorgänge mit Shell-Karten werden importiert.',
  'Produkt': 'Produkt',
  'Zadajte produkt': 'Produkt eingeben',
  'Druh': 'Art',
  'Do spotreby sa počíta iba palivo': 'Nur Kraftstoff zählt zum Verbrauch',
  'Množstvo (l)': 'Menge (l)',
  'Platba': 'Zahlung',
  'Suma s DPH (€)': 'Betrag inkl. MwSt. (€)',
  'Sadzba DPH (%)': 'MwSt.-Satz (%)',
  'Bez DPH: {net} – táto suma ide do nákladov': 'Ohne MwSt.: {net} – dieser Betrag zählt zu den Kosten',
  'Kto tankoval': 'Wer hat getankt',
  'Neurčený': 'Nicht angegeben',
  'Čerpacia stanica': 'Tankstelle',
  'napr. Shell Žilina': 'z. B. Shell Žilina',
  'Mesto': 'Ort',
  'AdBlue a nákupy na pumpe': 'AdBlue und Tankstelleneinkäufe',
  'Počítajú sa servisy a opravy s cenou, diaľničné známky, pokuty a tankovanie (palivo bez DPH).': 'Gezählt werden Wartungen und Reparaturen mit Preis, Vignetten, Bußgelder und Tankvorgänge (Kraftstoff ohne MwSt.).',
  'faktúry z doklado.sk.': 'Rechnungen aus doklado.sk.',
  'Palivo a spotreba': 'Kraftstoff und Verbrauch',
  'Tankovania vozidla': 'Tankvorgänge des Fahrzeugs',
  'Palivo bez DPH': 'Kraftstoff ohne MwSt.',
  'Natankované': 'Getankt',
  'Priemerná spotreba': 'Durchschnittsverbrauch',
  'Spotreba sa vypočíta pre mesiace, v ktorých sú tankovania aj GPS kilometre.': 'Der Verbrauch wird für Monate berechnet, in denen es sowohl Tankvorgänge als auch GPS-Kilometer gibt.',
  '1. štvrťrok': '1. Quartal',
  '2. štvrťrok': '2. Quartal',
  '3. štvrťrok': '3. Quartal',
  '4. štvrťrok': '4. Quartal',
  'Tankovanie zo Shell kariet aj v hotovosti – náklady, litre a spotreba podľa GPS kilometrov': 'Tanken mit Shell-Karten und bar – Kosten, Liter und Verbrauch nach GPS-Kilometern',
  'Celý rok': 'Ganzes Jahr',
  'Pridať tankovanie': 'Tankvorgang hinzufügen',
  'Tankovania': 'Tankvorgänge',
  'Import zo Shell karty': 'Import von Shell-Karte',
  'V tomto období nie je žiadne tankovanie': 'Keine Tankvorgänge in diesem Zeitraum',
  'Importujte export transakcií zo Shell karty alebo pridajte tankovanie ručne.': 'Importieren Sie den Transaktionsexport der Shell-Karte oder fügen Sie Tankvorgänge manuell hinzu.',
  'Priem. cena / l': 'Ø Preis / l',
  'Km podľa GPS': 'km laut GPS',
  'Najvyššia spotreba': 'Höchster Verbrauch',
  'Palivo € / km': 'Kraftstoff € / km',
  'AdBlue a iné': 'AdBlue und Sonstiges',
  'Upozornenia': 'Hinweise',
  'Tankovanie iného paliva, než má vozidlo zapísané': 'Anderer Kraftstoff getankt als beim Fahrzeug eingetragen',
  '{count}× iné palivo': '{count}× anderer Kraftstoff',
  's DPH spolu {amount}': 'inkl. MwSt. insgesamt {amount}',
  '{count} transakcií': '{count} Transaktionen',
  'Priemerná cena': 'Durchschnittspreis',
  's DPH, ako na pumpe': 'inkl. MwSt., wie an der Zapfsäule',
  'chýbajú GPS kilometre': 'GPS-Kilometer fehlen',
  'na 100 km podľa GPS': 'pro 100 km laut GPS',
  'AdBlue {amount}': 'AdBlue {amount}',
  'Spotreba = litre paliva ÷ GPS kilometre v mesiacoch, ktoré majú oboje. Kliknite na vozidlo pre jeho tankovania.': 'Verbrauch = Liter Kraftstoff ÷ GPS-Kilometer in Monaten, die beides haben. Klicken Sie auf ein Fahrzeug für seine Tankvorgänge.',
  'Podľa mesiacov': 'Nach Monaten',
  'Palivo bez DPH a natankované litre': 'Kraftstoff ohne MwSt. und getankte Liter',
  'Neznáma': 'Unbekannt',
  'Podľa platby': 'Nach Zahlungsart',
  'Vozidlo má zapísané iné palivo': 'Beim Fahrzeug ist ein anderer Kraftstoff eingetragen',
  'iné palivo': 'anderer Kraftstoff',
  'Množstvo': 'Menge',
  'Bez DPH': 'Ohne MwSt.',
  's DPH {amount}': 'inkl. MwSt. {amount}',
  'Kde': 'Wo',
  'faktúra {invoice}': 'Rechnung {invoice}',
  'zatiaľ nevyfakturované': 'noch nicht abgerechnet',
  'Produkt, stanica, meno, faktúra…': 'Produkt, Tankstelle, Name, Rechnung…',
  'Zdroj': 'Quelle',
  'Shell karta (import)': 'Shell-Karte (Import)',
  'Zadané ručne': 'Manuell eingegeben',
  '{count} transakcií · palivo {liters} · bez DPH {net} · s DPH {gross}': '{count} Transaktionen · Kraftstoff {liters} · ohne MwSt. {net} · inkl. MwSt. {gross}',
  'Žiadne tankovanie nezodpovedá filtru': 'Kein Tankvorgang entspricht dem Filter',
  'Zmazať tankovanie': 'Tankvorgang löschen',
  'Zmazať transakciu {product} {amount} ({date})? Pri ďalšom importe toho istého obdobia sa znova pridá.': 'Transaktion {product} {amount} ({date}) löschen? Beim nächsten Import desselben Zeitraums wird sie erneut hinzugefügt.',
  'Zmazať tankovanie {product} {amount} ({date})?': 'Tankvorgang {product} {amount} ({date}) löschen?',
  'Tankovanie bolo zmazané': 'Tankvorgang gelöscht',
  '{rejected} súbor(ov) nie je vo formáte CSV ani XLSX': '{rejected} Datei(en) sind weder CSV noch XLSX',
  'Import dokončený – nové: {created}, aktualizované: {updated}': 'Import abgeschlossen – neu: {created}, aktualisiert: {updated}',
  'Nové transakcie': 'Neue Transaktionen',
  'Aktualizované': 'Aktualisiert',
  'Bez zmeny (už importované)': 'Unverändert (bereits importiert)',
  'Preskočené': 'Übersprungen',
  'Preskočené – vozidlá nie sú v systéme: {plates}': 'Übersprungen – Fahrzeuge nicht im System: {plates}',
  'Importovať ďalší súbor': 'Weitere Datei importieren',
  'Zobraziť prehľad': 'Übersicht anzeigen',
  'Pretiahnite sem export transakcií zo Shell karty (CSV alebo XLSX) alebo kliknite pre výber': 'Ziehen Sie den Transaktionsexport der Shell-Karte (CSV oder XLSX) hierher oder klicken Sie zur Auswahl',
  'Súbor „transactions-…“ z portálu Shell / Fleetcor, napr. za mesiac alebo štvrťrok. Obdobia sa môžu prekrývať – už importované transakcie sa nepridajú druhýkrát, iba sa aktualizujú (napr. keď sú medzičasom vyfakturované). Pred importom uvidíte náhľad.': 'Die Datei „transactions-…“ aus dem Shell-/Fleetcor-Portal, z. B. für einen Monat oder ein Quartal. Zeiträume dürfen sich überschneiden – bereits importierte Transaktionen werden nicht doppelt hinzugefügt, nur aktualisiert (z. B. sobald sie abgerechnet sind). Vor dem Import sehen Sie eine Vorschau.',
  '{rows} riadkov': '{rows} Zeilen',
  'Odobrať súbor': 'Datei entfernen',
  'Náhľad importu': 'Importvorschau',
  'Obdobie {from} – {to}': 'Zeitraum {from} – {to}',
  'Transakcie': 'Transaktionen',
  'Už importované': 'Bereits importiert',
  'Litre paliva': 'Liter Kraftstoff',
  'Tieto ŠPZ nie sú v systéme: {plates}': 'Diese Kennzeichen sind nicht im System: {plates}',
  'Založiť chýbajúce vozidlá (inak sa ich transakcie preskočia)': 'Fehlende Fahrzeuge anlegen (sonst werden ihre Transaktionen übersprungen)',
  'Iné palivo, než má vozidlo zapísané ({count}×) – skontrolujte druh paliva vozidla': 'Anderer Kraftstoff als beim Fahrzeug eingetragen ({count}×) – prüfen Sie die Kraftstoffart des Fahrzeugs',
  'Spolu bez DPH {amount}': 'Gesamt ohne MwSt. {amount}',
  'Chyby ({count})': 'Fehler ({count})',
  '{file}, riadok {row}: {errors}': '{file}, Zeile {row}: {errors}',
  'AdBlue': 'AdBlue',
  'Ostatné (oleje, príslušenstvo, umývanie…)': 'Sonstiges (Öle, Zubehör, Autowäsche…)',
  'Palivová karta (Shell)': 'Tankkarte (Shell)',
  'Hotovosť': 'Bargeld',
  'Súkromná karta': 'Private Karte',
  'Iná firemná karta / iné': 'Andere Firmenkarte / Sonstiges',
  'Kombinovaná spotreba podľa TP (l/100 km)': 'Kombinierter Verbrauch laut Fahrzeugschein (l/100 km)',
  'napr. 6,2': 'z. B. 6,2',
  'Z technického preukazu – porovnáva sa so skutočným tankovaním': 'Aus dem Fahrzeugschein – wird mit den tatsächlichen Tankvorgängen verglichen',
  'Zadajte číslo od 0 do 50': 'Geben Sie eine Zahl von 0 bis 50 ein',
  'Objem nádrže (l)': 'Tankinhalt (l)',
  'napr. 50': 'z. B. 50',
  'Zadajte číslo od 0 do 500': 'Geben Sie eine Zahl von 0 bis 500 ein',
  'Spotreba podľa TP': 'Verbrauch laut Fahrzeugschein',
  'nádrž {liters} l': 'Tank {liters} l',
  'Hospodárna jazda': 'Sparsame Fahrweise',
  'Zvýšená spotreba': 'Erhöhter Verbrauch',
  'Agresívna jazda': 'Aggressive Fahrweise',
  'Oproti spotrebe podľa technického preukazu': 'Im Vergleich zum Verbrauch laut Fahrzeugschein',
  'Štýl jazdy': 'Fahrweise',
  'chýbajú GPS km': 'GPS-km fehlen',
  'bez spotreby podľa TP': 'kein offizieller Verbrauch',
  '{count} nádrže': '{count} Tankfüllungen',
  'Štýl jazdy podľa technického preukazu': 'Fahrweise laut Fahrzeugschein',
  'Koľko sa natankovalo oproti tomu, koľko by auto podľa TP spotrebovalo na najazdené GPS kilometre. Do +15 % hospodárna jazda, do +30 % zvýšená spotreba, nad 30 % agresívna jazda.': 'Wie viel getankt wurde im Vergleich dazu, was das Auto laut Fahrzeugschein für die GPS-Kilometer verbrauchen sollte. Bis +15 % sparsam, bis +30 % erhöhter Verbrauch, über 30 % aggressive Fahrweise.',
  'TP {value} l/100 km': 'offiziell {value} l/100 km',
  'Očakávané podľa TP': 'Erwartet (offiziell)',
  '{count}× tankovanie': '{count}× getankt',
  'Reálna spotreba': 'Tatsächlicher Verbrauch',
  'Zatiaľ nie je čo hodnotiť – vozidlá potrebujú spotrebu podľa TP, tankovania aj GPS kilometre v tom istom mesiaci.': 'Noch nichts zu bewerten – Fahrzeuge brauchen einen offiziellen Verbrauch, Tankvorgänge und GPS-Kilometer im selben Monat.',
  'Doplňte spotrebu podľa TP a objem nádrže v karte vozidla:': 'Ergänzen Sie den offiziellen Verbrauch und den Tankinhalt in der Fahrzeugkarte:',
};
